import type { ProtocolStepDraft } from '../schemas/protocol.js';

/**
 * May this step become an ÉTAPE D'ADIEU (issue #163, §7.2, H92)? True when it
 * carries no objective and no exit condition.
 *
 * Deliberately NOT `isEmptyStep` (`jumps.ts`): the frise's « étape vide » also
 * demands an empty direction, and a farewell step keeps its direction - it is
 * what the goodbye is written from. The editor greys the checkbox on it (« Retirez
 * d'abord les objectifs et les conditions de cette étape. ») and
 * `protocolProblems` refuses a farewell step that is not eligible
 * (`farewell-step-not-empty`, H77): one rule, two readers, so the box and the
 * refusal cannot disagree.
 */
export function farewellEligible(
  step: Pick<ProtocolStepDraft, 'objectives' | 'conditions'>,
): boolean {
  return step.objectives.length === 0 && step.conditions.length === 0;
}
